import axios from 'axios'
import ErrorMessage from '../../properties/errorMessage'

const baseURL = 'https://k2v1llw233.execute-api.ap-northeast-1.amazonaws.com/v1'

const Requests = axios.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json',
  withCredentials: false
})

const defaultErrorHandler = (response, $parent) => {

  let data = response.response.data
  let errorCode = data ? data.error.code : 5002

  $parent.$dialog.alert({
    title: 'エラー',
    message: `${ErrorMessage[errorCode]}<br>コード：<b>${errorCode}</b>`,
    type: 'is-danger',
    hasIcon: true
    // icon: 'times-circle',
    // iconPack: 'fa'
  })

  $parent.loading.isActive = false
  $parent.isModalActive = false

  return false
}


export { Requests, defaultErrorHandler }



// WEBPACK FOOTER //
// ./src/modules/request/base.js